import styled from 'styled-components/native';

import { moderateScale } from '../../../utils/scaleHelpers';
import { H1 } from '../../base_ui';

export const HomeH1 = styled(H1)`
  padding: 0 ${moderateScale(24)}px;
`;
